import { Button, Modal } from 'react-bootstrap';
import XpektorButton from '../../../Components/XpektorButton/XpektorButton';
import './XpektorBootstrapModal.scss';

const gsT = (t, key) => t(`shared${key}`);

/* eslint-disable react/prop-types */
export default function ConfirmActionModal({
  handleClose,
  description,
  actionButtonText,
  danger,
  onConfirm,
  t,
}) {
  return (
    <Modal
      show
      onHide={handleClose}
      backdrop="static"
      keyboard={false}
      className="border-0 xpektor-bootstrap-modal"
      centered
    >
      <Modal.Header className="xpektor-bootstrap-modal">
        <Modal.Title>{t('modal.confirm-action.modal-title')}</Modal.Title>
        <Button className="btn-close" bsPrefix="button" onClick={handleClose} />
      </Modal.Header>
      <Modal.Body className="border-0">
        <p className="confirm-description">
          {description}
          <br />
          <br />
          {t('modal.confirm-action.continue')}
        </p>
        <div className="confirm-row">
          <XpektorButton
            content={actionButtonText}
            onClick={() => {
              onConfirm();
              handleClose();
            }}
            variant={danger ? 'red' : ''}
          />
          <XpektorButton
            content={gsT('.actions.cancel')}
            variant="outline"
            onClick={handleClose}
          />
        </div>
      </Modal.Body>
    </Modal>
  );
}
